/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import { type ForwardedRef, forwardRef } from 'react';
import { type IconProps, Icon } from '../../components/icon/icon.component';

const EditFillIcon = forwardRef((props: IconProps, ref: ForwardedRef<SVGSVGElement>) => {
  return (
    <Icon isFilled {...props} ref={ref}>
      <svg width="24" height="24" viewBox="0 0 24 24">
        <path d="M10.1516 18.7411C10.2626 18.6942 10.3635 18.6263 10.4487 18.541L17.7955 11.1943L12.7941 6.19288L5.39537 13.5494C5.3073 13.637 5.23756 13.7412 5.19022 13.856L2.57064 20.2085C2.4261 20.559 2.50753 20.9621 2.77681 21.229C3.04608 21.4959 3.44988 21.5738 3.79911 21.4262L10.1516 18.7411Z" />
        <path d="M15.9164 3.12233C15.6901 3.31331 15.4378 3.56423 15.1532 3.84725L14.1232 4.87726L19.1178 9.87193L20.141 8.84872C20.4256 8.56417 20.6779 8.31196 20.8699 8.08576C21.0745 7.84476 21.265 7.5725 21.3756 7.23221C21.5373 6.73455 21.5373 6.19847 21.3756 5.70081C21.265 5.36052 21.0745 5.08827 20.8699 4.84726C20.6779 4.62106 20.4256 4.36879 20.141 4.08423L19.9108 3.85407C19.627 3.57023 19.3754 3.31859 19.1497 3.12696C18.9092 2.92276 18.6376 2.73256 18.2981 2.62193C17.8015 2.46011 17.2665 2.45934 16.7694 2.61975C16.4296 2.7294 16.1574 2.91882 15.9164 3.12233Z" />
      </svg>
    </Icon>
  );
});

export { EditFillIcon };
